import React from 'react'
import { TextAreaInput } from './TextAreaInput'
import type { InlineInputProps } from '../InlineInput'
import { InlineInput } from '../InlineInput'

export const TextAreaInlineInput = ({
  parentInputComponent,
  displayContent,
  editContent,
  inputProps,
  ...rest
}: InlineInputProps) => {
  const ParentInput = parentInputComponent || InlineInput

  displayContent =
    displayContent ??
    ((value, onClick) => (
      <div
        style={{ whiteSpace: 'pre-line' }}
        onClick={(e) => {
          e.preventDefault()
          return onClick(value)
        }}
      >
        {value}
      </div>
    ))

  editContent = editContent ?? ((props) => <TextAreaInput {...{ ...props, ...inputProps }} />)

  return <ParentInput displayContent={displayContent} editContent={editContent} inputProps={inputProps} {...rest} />
}
